export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_02.22d1f717.jpg";